import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=f83a290e&scoped=true&"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&id=f83a290e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83a290e",
  null
  
)

export default component.exports